export default class Country {
    public id: number = 0;
    public tag: string = '';

    public static fromData(data: any): Country {
        const country = new Country();
        country.id = data.id;
        country.tag = data.tag;

        return country;
    }
}
